import {ShellHint} from './shell-hint';

/**
 * Router načítá `loadComponent` cílové route až po vyhodnocení guardů, tedy sériově za
 * obnovou Firebase session. Když stejný modul naimportujeme hned při bootstrapu, prohlížeč
 * ho stahuje souběžně s auth requesty a routeru se pak `import()` vrátí z cache modulů.
 *
 * Specifier musí ukazovat na týž soubor jako `loadComponent` v `apps.routes.ts`, jinak by
 * vznikl druhý chunk.
 */
const loadDashboard = (): Promise<unknown> => import('../../apps/dashboard/dashboard/dashboard.component');

/** Cesty, které končí na dashboardu: kořen (redirect) a dashboard sám. */
function targetsDashboard(pathname: string): boolean {
    const normalized = pathname.replace(/\/+$/, '') || '/';
    return normalized === '/' || normalized === '/page/dashboard';
}

/**
 * Předstáhne chunk dashboardu, pokud na něj míří první navigace a poslední známý auth stav
 * byl přihlášený uživatel. Selhání (stale chunk po deployi) se tiše spolkne — router při
 * vlastní navigaci narazí na totéž a projde standardní obsluhou (`isStaleChunkError`).
 */
export function warmUpInitialRoute(
    pathname: string,
    hint: ShellHint | null,
    load: () => Promise<unknown> = loadDashboard,
): Promise<void> {
    if (hint !== 'app' || !targetsDashboard(pathname)) {
        return Promise.resolve();
    }
    return load().then(() => undefined, () => undefined);
}
